module.exports = __webpack_public_path__ + "img/tick.75ca5f22.svg";